import { Component, OnInit, HostListener, ViewChild, ViewChildren} from '@angular/core';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { DamserviceService } from "../dam/damservice.service";
import { AuthService } from "angularx-social-login";
import { OrganisationService } from "../create-organisation/organisation.service";
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { slideInOutAnimation } from '../sliding-screen/sliding-screen.animations';
import AOS from 'aos';

@Component({
  selector: 'app-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.css'],
  animations: [slideInOutAnimation]
})
export class LibraryComponent implements OnInit {

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private titleService: Title,
    private metaTagService: Meta,
    private damService: DamserviceService,
    private authService: AuthService,
    private organisationService: OrganisationService,
    private fb: FormBuilder,
  ) { }

  workspaces = [];
  boardIdsList = [];
  notifications = [];

  searchLibrarySection: boolean = false;
  librarySection: boolean = true;

  currentUser: User;
  mobileView: boolean = false;
  userPic: any;
  workspaceId: any;
  workspaceName: string;
  userRole: string;
  planName: string;
  ownerEmail: String;
  ownerName: String;
  totalSpaceAllowed: any;
  consumedSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  workspaceCountAllowed: any;
  totalWorkspaceCreated: any;
  planId: any;

  searchText: any;

  sendSuccessfulMsg: boolean = false;
  sendSuccessfulErrorMsg: boolean = false;
  sendSuccessfulErrorMessage: string;
  successfullMessage: string;
  showTopRightLoader: boolean = false;

  hitEditorAddApi: any;
  contentMainId: any;
  showLeaveLoader: boolean = false;
  radioImages: boolean = false;
  radioText: boolean = true;
  addImagesCounter: any = 0;
  showOnlyAddImagesSubmitBtn: boolean = false;

  addContentStyle = "none";
  goProPlanStyle = "none";
  contentTextName: any;
  contentImageName: any;
  contentEditData: string = '';
  contentLibraryType: any;
  checkAddImages: boolean = false;

  count: number = 0;
  discoverList = [];
  libraryDeleteList = [];
  searchLibraryList = [];
  discoverListTitle: any;

  commaSeparatedLines: string;
  pastedLines = [];
  urlList = [];
  urlListBinary = [];
  libraryContentList = [];
  libraryContent: boolean = false;
  searchLibraryContent: boolean = false;
  libraryImagesContent = [];
  discoverContentList = [];
  libraryImagesContentList: boolean = true;
  selectedFiles: FileList;
  lineNumber: number = 1;

  isSelected: boolean[] = [true, false, false, false];
  showMyLibrary: boolean = true;
  showDiscover: boolean = false;

  assetEditTagsStyle = "none";
  showEditTagsLoader: boolean = false;
  editTagsError: any;
  libContentId: any;
  editTagsList: string[] = [];
  addedTagsList: Array<{tags: string}> = [];
  hideTextInputField: boolean = false;
  contentControl: FormControl = new FormControl('');

  public isEmojiPickerVisible: boolean;
  @ViewChild("libContentData") commentFieldLib;

  showLibraryContent = false;
  libraryTextContent: any;
  selectedEmoji: string = '';
  emojiFile: any;
  contentType: any;

  items: string[] = [];
  imageSelected: boolean = false;
  showAddToLibSection: boolean = false;
  showAddToLibButton: boolean = false;
  changeColor = [false, false, false];
  changeColors = [false, false, false];
  @ViewChildren("checkboxes") checkboxes;

  tagsForm = this.fb.group({
    edittags: ['', Validators.required],
  });

  addContentTextForm = this.fb.group({
    textname: ['', Validators.required],
  });

  addContentImagesForm = this.fb.group({
    imagesname: ['', Validators.required],
  });

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) { // 768px portrait
      this.mobileView = true;
    }else{
      this.mobileView = false;
    }

    this.titleService.setTitle("Content library | Workspace | Crafttor");
    this.metaTagService.addTags([
      { name: 'description', content: 'Content library provides a feature to use predefined text and images within plugins for better design outcomes.'},
      { name: 'keywords', content: 'library, content library, user content, content, data, designs' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    AOS.init();

    if(this.currentUser) {
      this.getWorkspaceDetails();
      this.getUserPic();;
    } else {
      this.router.navigate(['/login']);
    }
  }

  getWorkspaceDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.getCurrentUserData(this.workspaceId);
  }

  getUserPic() {
    this.damService.getUserPic().subscribe((data: any) => {
      this.userPic = data.user_pic;
    });
  }

  getCurrentUserData(workspaceId: any) {
    this.damService.getCurrentUserData(workspaceId).subscribe((data: any) => {
      this.userRole = data.role;
      this.ownerListApi();
      this.listWorkspace();
    },
    (error) => {
      if (this.currentUser) {
        if(error.status == 500){
        } else {

        }
      } else {
        this.router.navigate(['/login']);
      }
    });
  }

  ownerListApi(){
    this.damService.getOwnerList(this.workspaceId).subscribe((data: any) => {
      this.ownerEmail = data.email;
      this.planName = data.plan_title;
      this.ownerName = data.first_name + " " + data.last_name;
      this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000
      this.consumedSpaceAllowed = data.current_dam_space/1000
      this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000
      this.planId = data.plan_id;
      this.workspaceCountAllowed = data.allowed_workspace;
      this.totalWorkspaceCreated = data.total_workspace_created;
    });
  }

  listWorkspace(){
    if (this.currentUser) {
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        if(data.length > 0){
          this.workspaces = data;
          this.getMyLibraryContent();
          }else{
            this.router.navigate(['/create-workspace']);
          }
        });
      }else{
        this.router.navigate(['/login']);
      }
  }

  goToMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  goToFeedback() {
    window.open("https://workspace.crafttor.com/feedbacks", "_blank");
  }

  personalClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/personal']);
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/home']);
  }

  openLoginScreen() {
    this.router.navigate(['/login']);
  }

  backToWorkspace() {
    this.router.navigate(['/dam']);
  }

  goToSubscription() {
    this.router.navigate(['/dam/subscription']);
  }

  openContentDialog(value: any, type: any, contentId: any, contentTitle: any,
    coverImg: any, contentData: any) {
      this.hitEditorAddApi = value;
      this.contentMainId = contentId;
      if(value == 'Edit') {
        if(type == 'text') {
          this.radioText = true;
          this.radioImages = false;
          this.contentTextName = contentTitle;
          this.contentLibraryType = type;
          for (let typeData of contentData) {
            this.contentEditData += typeData.text_data + '\n';
          }
          // this.pastedLines.push(this.contentEditData);
          // for (let typeData of contentData) {
          //   console.log("Items logs sghown : "+typeData.text_data);
          //   this.contentEditData = typeData.text_data;
          // }
          this.selectedEmoji = this.convertUnicodeToEmoji(coverImg);
        } else if(type == 'image_file') {
          this.radioText = false;
          this.radioImages = true;
          this.contentImageName = contentTitle;
          this.contentLibraryType = type;
          for (let typeData of contentData) {
            this.contentEditData += typeData.image + '\n';
          }
          // this.contentEditData = contentData;
        }
        this.addContentStyle = "block";
      } else if(value == 'Add') {
        this.contentTextName = "";
        this.contentImageName = "";
        this.selectedEmoji = "";
        this.contentEditData = "";
        this.addContentStyle = "block";
      }
  }

  closeContentDialog() {
    this.showOnlyAddImagesSubmitBtn = false;
    this.showLeaveLoader = false;
    this.emojiFile = "";
    this.contentImageName = "";
    this.contentTextName = "";
    this.contentControl.reset();
    this.pastedLines = [];
    this.urlList = [];
    this.hideTextInputField = false;
    this.addContentStyle = "none";
  }

  closeImageContentDialog() {
    this.getMyLibraryContent();
    this.addContentStyle = "none";
    this.showLeaveLoader = false;
  }

  openGoProDialog() {
    this.goProPlanStyle = "block";
  }

  closeGoProDialog() {
    this.goProPlanStyle = "none";
  }

  submitContentTextData() {
    if(this.hitEditorAddApi == 'Edit') {
      this.editLibraryContent(this.contentMainId);
    } else if(this.hitEditorAddApi == 'Add') {
      this.uploadAllLibTextContent();
    }
  }

  submitContentImagesData() {
    if(this.showOnlyAddImagesSubmitBtn) {
      this.uploadFiles(event);
    } else {
      this.uploadAllLibraryContent();
    }
  }

  imagesClick() {
    this.radioImages = true;
    this.radioText=false;
  }

  textClick() {
    this.radioImages = false;
    this.radioText=true;
  }

  uploadAllLibTextContent() {
    if(this.addContentTextForm.valid && this.pastedLines.length > 0) {
      this.showLeaveLoader = true;
      this.damService.postLibraryTextContent(this.contentTextName,
        this.emojiFile, this.pastedLines, 'text').subscribe((data: any) => {
        this.showLeaveLoader = false;
        this.emojiFile = "";
        this.contentTextName = "";
        this.hideTextInputField = false;
        this.contentControl.reset();
        this.clearContentTextList();
        this.hideSuccesfullFunctionMsg();
        this.closeContentDialog();
        this.getMyLibraryContent();
      },
      (error) => {
        if(error.status == 400){
          this.closeContentDialog();
          this.showLeaveLoader = false;
          // this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.title[0];
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.closeContentDialog();
          this.showLeaveLoader = false;
          // this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.title[0];
          this.hideSuccesfullFunctionErrorDelete();
        }
      });
    }
  }

  uploadAllLibraryContent() {
    if(this.addContentImagesForm.valid && this.urlList.length > 0) {
      this.showLeaveLoader = true;
      this.damService.postLibraryImagesUrlContent(this.contentImageName,
        this.urlList, 'image_url').subscribe((data: any) => {
        this.showLeaveLoader = false;
        this.emojiFile = "";
        this.contentImageName = "";
        this.clearContentTextList();
        this.hideSuccesfullFunctionMsg();
        this.closeContentDialog();
        this.getMyLibraryContent();
      },
      (error) => {
        if(error.status == 400){
          this.closeContentDialog();
          this.showLeaveLoader = false;
          // this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.title[0];
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.closeContentDialog();
          this.showLeaveLoader = false;
          // this.sendSuccessfulErrorMsg = true;
          this.sendSuccessfulErrorMessage = error.error.title[0];
          this.hideSuccesfullFunctionErrorDelete();
        }
      });
    }
  }

  onFileSelected(event: any): void {
    const filess: FileList = event.target.files;
    this.urlList = [];

    for (let i = 0; i < filess.length; i++) {
      const file: File = filess[i];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.urlList.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    }

    const files = event.target.files;
    let isImage = true;
    for (let i = 0; i < files.length; i++) {
      if (files.item(i).type.match('image.*')) {
        continue;
      } else {
        isImage = false;
        alert('Invalid Format!');
        break;
      }
    }

    if (isImage) {
      this.selectedFiles = event.target.files;
      this.showOnlyAddImagesSubmitBtn = true;
    } else {
      this.selectedFiles = undefined;
      event.srcElement.percentage = null;
    }
  }

  uploadFiles(event): void {
    this.showLeaveLoader = true;
    for (let i = 0; i < this.selectedFiles.length; i++) {
      this.upload(i, this.selectedFiles[i]);
      this.addImagesCounter++;
    }
  }

  upload(idx:any, file: any): void {
    this.damService.uploadImagesContentLibrary(this.contentImageName, file, 'image_file').subscribe(
      event => {
        if(this.selectedFiles.length == this.addImagesCounter) {
          this.showOnlyAddImagesSubmitBtn = false;
          this.showLeaveLoader = false;
          this.emojiFile = "";
          this.contentImageName = "";
          this.clearContentTextList();
          this.hideSuccesfullFunctionMsg();
          this.closeContentDialog();
          this.getMyLibraryContent();
        }
      },
      (error: any) => {
        if(error.status == 400){
          this.showLeaveLoader = false;
          // this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        } else {
          this.showLeaveLoader = false;
          // this.sendSuccessfulErrorMsg = true
          this.sendSuccessfulErrorMessage = error.error.message;
          this.hideSuccesfullFunctionErrorDelete();
        }
     });
  }

  getMyLibraryContent() {
    this.showTopRightLoader = true;
    this.damService.getMyLibraryContent().subscribe((data: any) => {
      this.showTopRightLoader = false;
      if(data['results'].length == 0) {
        this.libraryContent = true;
      } else {
        this.libraryContent = false;
      }
      this.libraryContentList = data['results'];
    },
    (error) => {
      if(error.status == 400){
        this.showTopRightLoader = false;
        // this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.showTopRightLoader = false;
        // this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
    });
  }

  getDiscoverContent() {
    this.showTopRightLoader = true;
    this.damService.getDiscoverContent().subscribe((data: any) => {
      this.showTopRightLoader = false;
      this.discoverContentList = data['results'];
    },
    (error) => {
      if(error.status == 400){
        this.showTopRightLoader = false;
        // this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.showTopRightLoader = false;
        // this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
    });
  }

  editLibraryContent(contentId: any) {
    this.showLeaveLoader = true;
    this.damService.editLibraryContent(this.contentTextName, this.contentEditData,
      contentId).subscribe((data: any) => {
      this.getMyLibraryContent();
      this.showLeaveLoader = false;
      this.sendSuccessfulMsg = true;
      this.contentControl.reset();
      this.clearContentTextList();
      this.closeContentDialog();
      this.successfullMessage = data.message;
      this.hideSuccesfullFunctionMsg();
    },
    (error) => {
      if(error.status == 400){
        this.showLeaveLoader = false;
        // this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.showLeaveLoader = false;
        // this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
    });
  }

  deleteLibraryContent(contentId: any) {
    this.showTopRightLoader = true;
    this.damService.deleteLibraryContent(contentId).subscribe((data: any) => {
      this.showTopRightLoader = false;
      this.getMyLibraryContent();
      this.onSubmit();
      if(data.message) {
        this.sendSuccessfulMsg = true;
        this.successfullMessage = data.message;
        this.hideSuccesfullFunctionMsg();
      }
    },
    (error) => {
      if(error.status == 400){
        this.showTopRightLoader = false;
        // this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.showTopRightLoader = false;
        // this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
    });
  }

  deleteMultipleLibraryContent() {
    this.showTopRightLoader = true;
    this.damService.deleteMultipleLibraryContent(this.libraryDeleteList).subscribe((data: any) => {
      this.showTopRightLoader = false;
      this.getMyLibraryContent();
      this.cancelUsersSelection();
      if(data.message) {
        this.sendSuccessfulMsg = true;
        this.successfullMessage = data.message;
        this.hideSuccesfullFunctionMsg();
      }
    },
    (error) => {
      if(error.status == 400){
        this.showTopRightLoader = false;
        // this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.showTopRightLoader = false;
        // this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
    });
  }

  addDiscoverToLibrary() {
    this.showTopRightLoader = true;
    this.damService.addDiscoverToMyLibrary(this.discoverList).subscribe((data: any) => {
      this.showTopRightLoader = false;
      this.sendSuccessfulMsg = true;
      if(this.discoverList.length == 1) {
        this.successfullMessage = this.discoverListTitle + " added to library";
      } else {
        this.successfullMessage = "Added to library";
      }
      this.getDiscoverContent();
      this.hideSuccesfullFunctionMsg();
      this.cancelUsersSelection();
    },
    (error) => {
      if(error.status == 400){
        this.showTopRightLoader = false;
        this.discoverListTitle = "";
        this.sendSuccessfulErrorMsg = true;
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true;
        this.discoverListTitle = "";
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
    });
  }

  clearContentImagesList() {
    this.urlList = [];

  }

  clearContentTextList() {
    this.showOnlyAddImagesSubmitBtn = false;
    this.showLeaveLoader = false;
    this.emojiFile = "";
    this.contentImageName = "";
    this.contentTextName = "";
    this.contentControl.reset();
    this.pastedLines = [];
    this.urlList = [];
    this.hideTextInputField = false;
  }

  hideSuccesfullFunctionErrorDelete(){
    setTimeout(() => {
      this.sendSuccessfulErrorMsg = false;
    }, 3000);
  }

  hideSuccesfullFunctionMsg(){
    setTimeout(() => {
      this.sendSuccessfulMsg = false;
    }, 3000);
  }

  getNotifications() {
    this.newNotification ();
  }

  newNotification () {
    this.damService.newNotifications(this.workspaceId).subscribe((data: any) => {
      this.notifications = data['notifcation'];
    });
  }

  getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }

  getName(fullEmail: string) {
    return fullEmail.split(' ').map(n => n[0]).join('').toUpperCase();
  }

  getInitial(fullEmail: string) {
    return fullEmail.split(' ').map(n => n[0]).join('').toUpperCase();
  }

  openFigma() {
    window.open("https://www.figma.com/community/plugin/902086023682633830/Crafttor", "_blank");
  }

  openSketch() {
    window.open("https://crafttor.com/sketch", "_blank");
  }

  openIllustrator() {
    window.open("https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator", "_blank");
  }

  showUpgradePlans(){
    window.scrollTo(0, 0);
    if (this.currentUser) {
      this.router.navigate(['/dam/subscription']);
    }
  }

  @HostListener('document:paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    if(this.radioText) {
      this.contentControl.reset();
      this.hideTextInputField = true;
      const pastedText = event.clipboardData.getData('text');
      const lines = pastedText.split('\n').map(line => line.trim()).filter(line => line !== '');
      this.pastedLines = lines;
      event.preventDefault();
    } else if(this.radioImages) {
      const pastedText = event.clipboardData.getData('text');
      const urls = this.extractUrls(pastedText);
      this.checkAddImages = false;
      this.urlList = urls;
      event.preventDefault();
    }
  }

  onInputChange(event: any) {
    const inputValue: string = event.target.value;
    const lines = inputValue.split('\n').map(line => line.trim()).filter(line => line !== '');
    this.pastedLines = lines;
  }

  extractImageUrls(text: string): string[] {
    const urlsRegex = /"(.*?)"/g; // Regex to match URLs within quotes
    const matches = text.match(urlsRegex); // Extract URLs from text
    if (matches) {
      // Remove quotes from each match and return the URLs
      return matches.map(match => match.replace(/"/g, ''));
    } else {
      return [];
    }
  }

  private extractUrls(text: string): string[] {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.match(urlRegex) || [];
  }

  toggleLibraryContent(totalLibraryContent: any, contentType: any): void {
    this.libraryTextContent = totalLibraryContent;
    this.contentType = contentType;
    if(!this.showLibraryContent) {
      this.showLibraryContent = !this.showLibraryContent;
    }
  }

  closeToggleLibraryContent(): void {
    this.showLibraryContent = !this.showLibraryContent;
  }

  hideSuccesfullFunction(){
    setTimeout(() => {
      this.sendSuccessfulMsg = false;
    }, 3000);
  }

  public addEmojiLib(emoji: string): void {
    this.selectedEmoji = emoji;
    this.isEmojiPickerVisible = false;
    this.commentFieldLib.nativeElement.focus();
    this.emojiFile = this.getUnicodeForEmoji(this.selectedEmoji);
  }

  getUnicodeForEmoji(emoji: string): string {
    const codePoints = emoji.codePointAt(0)?.toString(16).toUpperCase();
    if (!codePoints) {
      return '';
    }
    return 'U+' + codePoints.padStart(4, '0');
  }

  convertUnicodeToEmoji(unicodeString: string): string {
    unicodeString = unicodeString.replace(/\\|U\+/g, '');
    const codePoints = unicodeString.split(/[\s\+]+/).map(part => parseInt(part.trim(), 16));
    const validCodePoints = codePoints.filter(codePoint => !isNaN(codePoint));
    if (validCodePoints.length === 0) {
      return '';
    }
    return String.fromCodePoint(...validCodePoints);
  }

  myLibraryClick(index: number) {
    this.isSelected = this.isSelected.map((item, i) => i === index);
    if(this.showLibraryContent) {
      this.showLibraryContent = !this.showLibraryContent;
    }
    this.discoverList = [];
    this.discoverListTitle = "";
    this.getMyLibraryContent();
    this.cancelUsersSelection();
    this.searchText = "";
    this.showMyLibrary = true;
    this.showDiscover = false;
    this.librarySection = true;
    this.searchLibrarySection = false;
  }

  discoverClick(index: number) {
    this.isSelected = this.isSelected.map((item, i) => i === index);
    if(this.showLibraryContent) {
      this.showLibraryContent = !this.showLibraryContent;
    }
    this.getDiscoverContent();
    this.cancelUsersSelection();
    this.searchText = "";
    this.showMyLibrary = false;
    this.showDiscover = true;
    this.librarySection = true;
    this.searchLibrarySection = false;
  }

  toggleDiscoverSelection(textContent: any) {
    textContent.selected = !textContent.selected;

    if(textContent.selected) {
      this.discoverList.push(textContent.id);
    } else {
      let index = this.discoverList.indexOf(textContent.id);
      if (index !== -1) {
        this.discoverList.splice(index, 1);
      }
    }
  }

  onSubmit() {
    if(this.searchText != '') {
      this.searchLibrary(this.searchText, 2);
    }
  }

  searchLibrary(searchText: any, index: number){
    this.cancelUsersSelection();
    this.damService.searchLibrary(searchText).subscribe((data: any) => {
      this.isSelected = this.isSelected.map((item, i) => i === index);
      if(data.length > 0) {
        this.searchLibraryContent = true;
      } else {
        this.searchLibraryContent = false;
      }
      this.searchLibraryList = data;
      this.showMyLibrary = false;
      this.showDiscover = false;
      this.librarySection = false;
      this.searchLibrarySection = true;
    });
  }

  openLibEditTagsDialog(libId: any, addedTags: any) {
      this.editTagsError = "";
      this.libContentId = libId;
      this.addedTagsList = addedTags.tags;
      this.assetEditTagsStyle = "block";
  }

  closeEditTagsDialog() {
    this.assetEditTagsStyle = "none";
  }

  onSubmitMultipleTags() {
    if(this.tagsForm.valid) {
      this.editTagsList.push(this.tagsForm.value['edittags']);
      this.tagsForm.reset();
    }
  }

  removeAddedTags(index: number) {
    this.editTagsList.splice(index, 1);
  }

  editMultipleTags() {
    this.editTagsError = "";
    if(this.editTagsList.length > 0) {
      this.showEditTagsLoader = true;
      this.damService.addMultipleLibraryTags(this.libContentId, this.editTagsList.join(', ')).subscribe((data: any) => {
          this.editTagsList = [];
          this.showEditTagsLoader = false;
          this.assetEditTagsStyle = "none";
          this.getMyLibraryContent();
          this.sendSuccessfulMsg = true;
          this.successfullMessage = "Tags added successfully!!"
          this.hideSuccesfullFunction();
      },
      (error: any) => {
        if(error.status == 403 || error.status == 400){
          this.showEditTagsLoader = false;
          this.editTagsError = error.error.message;
        } else {
          this.showEditTagsLoader = false;
          this.editTagsError = error.error.message;
        }
      });
    }
  }

  removeLibraryAddedTags(title: string, i: any){
    this.damService.deleteLibraryTags(this.libContentId, title).subscribe((data: any) => {
      this.addedTagsList.splice(i, 1);
      this.sendSuccessfulMsg = true;
      this.successfullMessage = "Tag removed successfully!!"
      this.hideSuccesfullFunction();
    });
  }

  addItem(text: string) {
    if (text.trim() !== '') {
      this.items.push(text);
    }
  }

  showAddToLibButtons(ivalue: any, i: any, textContent: any){
    this.showAddToLibSection = true;
    this.showAddToLibButton = true;
    this.imageSelected = true;
    // textContent.selected = !textContent.selected;
    if(ivalue == false){
      this.count--;
      if(this.count < 1){
        this.count = 0;
        this.imageSelected = false;
        this.showAddToLibSection = false;
        this.showAddToLibButton = false;
        this.discoverList = [];
        this.discoverListTitle = "";
        this.changeColor = [];
      }
      let index = this.discoverList.indexOf(textContent.id);
      if (index !== -1) {
        this.discoverList.splice(index, 1);
        this.discoverListTitle = "";
      }
    }else{
      this.count++;
      this.discoverList.push(textContent.id);
      this.discoverListTitle = textContent.title;
    }
  }

  showDeleteFromLibButtons(ivalue: any, i: any, textContent: any){
    this.showAddToLibSection = true;
    this.showAddToLibButton = false;
    this.imageSelected = true;
    if(ivalue == false){
      this.count--;
      if(this.count < 1){
        this.count = 0;
        this.imageSelected = false;
        this.showAddToLibSection = false;
        this.showAddToLibButton = false;
        this.libraryDeleteList = [];
        this.changeColors = [];
      }
      let index = this.discoverList.indexOf(textContent.id);
      if (index !== -1) {
        this.libraryDeleteList.splice(index, 1);
      }
    }else{
      this.count++;
      this.libraryDeleteList.push(textContent.id);
    }
  }

  cancelUsersSelection(){
    this.imageSelected = false;
    this.showAddToLibSection = false;
    this.discoverList = [];
    this.libraryDeleteList = [];
    this.discoverListTitle = "";
    this.changeColor = [];
    this.changeColors = [];
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = false;
    });
  }
}
